import { PlayerProperty, Save, Restore } from '../PlayerProperty';
import IPlayerData from '../../IPlayerData';
import { IPlayerState } from '../../../State/Player/IPlayerState';
import { PetId } from '../../../Constants/Pets';
import { report } from '../../../report';
import {
    restoreBoolean,
    restoreString,
    restoreStringifiedArray,
} from '../../ParseHelper';

const unlockedPetsKey = 'v1_71_5_unlockedPets' as const;
const activePetKey = 'v1_71_5_activePet' as const;
const petInDailyLogin = 'v1_71_5_petInDailyLogin' as const;

type PlayerStateKey = 'petsState';
type PlayerDataKeys =
    | typeof activePetKey
    | typeof unlockedPetsKey
    | typeof petInDailyLogin;

export default class Pets implements PlayerProperty<PlayerStateKey, PlayerDataKeys> {
    public isChanged(
        playerStateData: IPlayerState,
        playerEndpointData: IPlayerData
    ): boolean {
        const newEndpointData = this.save(playerStateData);
        return (
            newEndpointData[activePetKey] !==
                playerEndpointData[activePetKey] ||
            newEndpointData[unlockedPetsKey] !==
                playerEndpointData[unlockedPetsKey] ||
            newEndpointData[petInDailyLogin] !==
                Number(playerEndpointData[petInDailyLogin])
        );
    }

    public restore(playerEndpointData: IPlayerData): Restore<PlayerStateKey> {
        const unlockedPets = restoreStringifiedArray<string>(
            playerEndpointData[unlockedPetsKey]
        );
        const activePetString = restoreString(
            playerEndpointData[activePetKey],
            null
        );
        let activePet: PetId = restorePetIdFromString(activePetString) ??
            unlockedPets.length > 0 ? unlockedPets[unlockedPets.length - 1] as PetId : null;

        return {
            activePet,
            unlockedPets: unlockedPets
                .map((id) => restorePetIdFromString(id))
                .filter(id => id !== null),
            petInDailyLogin: restoreBoolean(
                playerEndpointData[petInDailyLogin],
                false
            ),
        };

        function restorePetIdFromString(petId: string): PetId {
            if (petId && !Object.values(PetId).includes(petId as PetId)) {
                report('Failed to restore petId.', {
                    sampleRate: 0.1,
                    once: true,
                    tags: {
                        petId,
                    },
                });
                return null;
            }
            return petId as PetId;
        }
    }

    public save(playerStateData: IPlayerState): Save<PlayerDataKeys> {
        return {
            [activePetKey]: playerStateData.petsState.activePet,
            [unlockedPetsKey]: JSON.stringify(
                playerStateData.petsState.unlockedPets
            ),
            [petInDailyLogin]: Number(
                playerStateData.petsState.petInDailyLogin
            ),
        };
    }
}
